export const queryKeys = {
  documentReminderOptions: 'documentReminderOptions',
  companyDocumentReminderSettings: (companyId) => [
    'companyDocumentReminderSettings',
    companyId,
  ],
  documentTypeList: () => ['documentTypeList'],
  documentVisibility: () => ['documentVisibility'],
  executerList: (serviceCompanyId) => ['executerList', serviceCompanyId],
  workersList: (serviceCompanyId) => ['workersList', serviceCompanyId],
  documentById: (id) => ['documentById', id],
  docsAttachments: (docId) => ['docsAttachments', docId],
  bindByDocs: (docId) => ['bindByDocs', docId],
  savedFilters: () => ['savedFilters'],
  allowedEntity: (typeId) => ['llowedEntity', typeId],
  attachedFile: ({ docId, fileName }) => ['attachedFile', docId, fileName],
  deadlineDate: ({ documentTypeId, inputDate, showResponseTimeDoc }) => [
    'deadlineDate',
    documentTypeId,
    inputDate,
    showResponseTimeDoc,
  ],
  lastComment: (docId) => ['lastComment', docId],
  statuses: () => ['statuses'],
  orgsDocs: (serviceCompanyId) => ['orgsDocs', serviceCompanyId],
  ordTypes: () => ['orgTypes'],
  subtypes: (docType) => ['subtypes', docType],
  topicsDocs: () => ['topicsDocs'],
  appealopicsDocs: () => ['appealopicsDocs'],
};
